// eslint-disable-next-line import/prefer-default-export
export const daysToExpire = 25
export const nightbotAccessTokenDaysToExpire = 30
export const SECONDS_IN_MINUTE = 60
export const SECONDS_IN_HOUR = 60 * SECONDS_IN_MINUTE
export const SECONDS_IN_DAY = SECONDS_IN_HOUR * 24
